import request from '@/requset'

// 登录
export function loginApi(data) {
  return request({
    url: 'api/pc/login',
    method: 'post',
    data
  })
}

// 获取凭证
export function getPublic(query) {
    return request({
      url: 'api/pc/public/cert?scope=cos',
      method: 'get',
      params: query
    })
  }

// 短信验证码
export function loginSmsApi(data) {
    return request({
        url: 'api/pc/sms',
        method: 'post',
        data
    })
}

// 图形验证码
export function loginMathApi(query) {
    return request({
        url: 'api/pc/captcha',
        method: 'get',
        params: query
    })
}

// 获取用户信息
export function getUserInfoApi(query) {
    return request({
        url: 'api/pc/user/info',
        method: 'get',
        params: query
    })
}

// 考试批次-列表
export function getTextListApi(query) {
    return request({
        url: 'api/pc/kspc',
        method: 'get',
        params: query
    })
}

// 考试成绩--列表
export function getResultsApi(query) {
    return request({
        url: 'api/pc/kscj',
        method: 'get',
        params: query
    })
}

// 支付-创建
export function addPayApi(data) {
    return request({
        url: 'api/pc/pay',
        method: 'post',
        data
    })
}

// 学籍资料-提交
export function addxjzlApi(data) {
    return request({
        url: 'api/pc/xjzl',
        method: 'post',
        data
    })
}

// 支付-查询
export function getPayApi(id) {
    return request({
        url: `api/pc/pay/${id}`,
        method: 'get',
        // params: query
    })
}

// 学籍资料-详情
export function getxjzlsApi(id) {
    return request({
        url: `api/pc/xjzl/${id}`,
        method: 'get',
        // params: query
    })
}

// 学籍资料-分页
export function getxjzlApi(query) {
    return request({
        url: 'api/pc/xjzl',
        method: 'get',
        params: query
    })
}

// 用户-准考证信息
export function getZkzApi(query) {
    return request({
        url: 'api/pc/user/zkz',
        method: 'get',
        params: query
    })
}

// 用户-准考证信息
export function getResultApi(query) {
    return request({
        url: 'api/pc/lqxx',
        method: 'get',
        params: query
    })
}

//获取配置
export function getSetting(query) {
    return request({
        url: 'api/pc/setting',
        method: 'get',
        params: query
    })
}

//报考专业
export function my_bkzy(query) {
    return request({
        url: 'api/pc/user/my_bkzy',
        method: 'get',
        params: query
    })
}

//报考专业
export function type_show(query) {
    return request({
        url: 'api/pc/recruit/type/show',
        method: 'get',
        params: query
    })
}
export function kspc_show(query) {
    return request({
        url: 'api/pc/kspc/show',
        method: 'get',
        params: query
    })
}